import { byId } from './domUtils';
import type { Root } from './prototypeTypes';
import { showToast, type ToastType } from './toastController';

/**
 * Renders feedback owned by the same user operation as a named UI surface.
 *
 * It deliberately never reads global modal state. Callers select this only
 * after determining that the message and surface describe the same operation;
 * unrelated asynchronous work keeps using Toast and may coexist with a modal.
 */
export function paintOperationFeedback(root: Root, id: string, message: string, kind: ToastType = 'error'): false {
	const alert = byId(root, id);
	if (!alert) {
		showToast({ type: kind, message });
		return false;
	}
	alert.textContent = message;
	alert.dataset.feedbackKind = kind;
	alert.setAttribute('role', kind === 'error' ? 'alert' : 'status');
	alert.setAttribute('aria-live', kind === 'error' ? 'assertive' : 'polite');
	alert.hidden = false;
	return false;
}

export function clearOperationFeedback(root: Root, id: string): void {
	const alert = byId(root, id);
	if (!alert) return;
	alert.textContent = '';
	delete alert.dataset.feedbackKind;
	alert.hidden = true;
}
